import axios from 'axios';
import cookie from 'js-cookie';

export default class AxiosApiService {
    constructor(url) {
        this.url = url;
        this.setHeaders();
    }

    setHeaders() {
        let access_token = this.access_token;
        let account_id = this.account_id;
        if (!access_token || !account_id || account_id == 'undefined' || access_token == 'undefined' || access_token == null || account_id == null) {
            this.axios = axios.create({
                baseURL: this.url,
            });
        } else {
            this.axios = axios.create({
                baseURL: this.url,
                headers: {
                    'Authorization': `Bearer ${access_token}`,
                    'Harvest-Account-Id': account_id,
                }
            });
        }
    }

    get(...params) {
        return this.axios.get(...params)
    }

    post(...params) {
        return this.axios.post(...params);
    }

    put(...params) {
        return this.axios.put(...params);
    }

    delete(...params) {
        return this.axios.delete(...params);
    }

    get access_token() {
        return cookie.get('harvest_token');
    }

    get account_id() {
        return cookie.get('harvest_account_id');
    }

    setCredentials(authData, scope) {
        cookie.set('harvest_token', authData.access_token, {expires: authData.expires_in});
        let account_id = '';

        if (String(scope).indexOf(':') !== -1) {
            try {
                let [scopeName, id] = scope.split(':');
                account_id = id;
            } catch (error) {
                console.log('error', error);
            }
        } else {
            account_id = scope;
        }

        cookie.set('harvest_account_id', account_id);
        this.setHeaders();
    }
}




// WEBPACK FOOTER //
// ./src/services/Axios.service.js